export default "__VITE_ASSET__QIWGF_6H__"